<template>
    <el-table
        :data="list"
        @selection-change="changeSelection"
        border
        height="calc(100% - 90px)"
        v-loadmore="loadMore"
    >
        <el-table-column align="center" type="selection" width="50" />
        <el-table-column label="素材名称">
            <template slot-scope="scope">
                <div
                    v-if="
                        canRename.show &&
                            selection[0].level &&
                            scope.row.labelId === selection[0].labelId
                    "
                >
                    <el-input style="width: 200px; margin-right: 10px;" v-model="canRename.name" />
                    <el-button @click="handleRename" icon="el-icon-check" />
                    <el-button @click="cancelRename" icon="el-icon-close" />
                </div>
                <div
                    v-else-if="
                        canRename.show &&
                            !selection[0].level &&
                            scope.row.fileId === selection[0].fileId
                    "
                >
                    <el-input style="width: 200px; margin-right: 10px;" v-model="canRename.name" />
                    <el-button @click="handleRename" icon="el-icon-check" />
                    <el-button @click="cancelRename" icon="el-icon-close" />
                </div>
                <div v-else>
                    <span
                        @click="clickLabel(scope.row)"
                        class="file-name"
                        v-if="scope.row.level"
                    >{{ scope.row.labelName }}</span>
                    <div v-else>
                        <img :src="scope.row.thumb" alt="加载失败" />
                        <span>{{ scope.row.fileName }}</span>
                    </div>
                </div>
            </template>
        </el-table-column>
        <el-table-column align="center" label="大小" prop="size" width="200" />
        <el-table-column align="center" label="修改时间" prop="modifyTime" width="200" />
    </el-table>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

const { mapState, mapActions } = createNamespacedHelpers('resource');

export default {
    computed: {
        ...mapState({
            list: (state) => state.list,
            total: (state) => state.total,
            search: (state) => state.search,
            canRename: (state) => state.canRename,
            selection: (state) => state.selection,
        }),
    },
    directives: {
        loadmore: {
            bind(el, binding) {
                var p = 0;
                var t = 0;
                var down = true;
                var selectWrap = el.querySelector('.el-table__body-wrapper');
                selectWrap.addEventListener('scroll', function () {
                    //判断是否向下滚动
                    p = this.scrollTop;
                    if (t < p) {
                        down = true;
                    } else {
                        down = false;
                    }
                    t = p; //判断是否到底
                    const sign = 0;
                    const scrollDistance =
                        this.scrollHeight - this.scrollTop - this.clientHeight;
                    if (scrollDistance <= sign && down) {
                        binding.value();
                    }
                });
            },
        },
    },
    methods: {
        ...mapActions([
            'changeSelection',
            'getLabelList',
            'getFileList',
            'pushPath',
            'changeCanRename',
            'renameLabel',
            'renameFile',
            'changeSearch',
        ]),
        async clickLabel({ labelName, level, labelId }) {
            this.pushPath({ labelName, level, labelId });
        },
        handleRename() {
            const current = this.selection[0];
            if (current.level) {
                this.renameLabel({
                    labelId: current.labelId,
                    name: this.canRename.name,
                });
            } else {
                this.renameFile({
                    labelFileId: current.labelFileId,
                    name: this.canRename.name,
                });
            }
        },
        cancelRename() {
            this.changeCanRename({ show: false, name: '' });
        },
        loadMore() {
            const { offset, count } = this.search;
            let data = offset + count;
            if (data < this.total) {
                this.changeSearch({ offset: data });
            } else {
                this.$message.info('已经到头啦！！！');
            }
        },
    },
};
</script>

<style lang="less" scoped>
.file-name {
    &:hover {
        color: #409eff;
        cursor: pointer;
    }
}
</style>
